import type { RequestPriority, StatusTab } from './types';

export const STATUS_META: Record<StatusTab, { label: string; tab: string }> = {
    all: { label: 'Все', tab: 'Все' },
    new: { label: 'Новое', tab: 'Новые' },
    work: { label: 'В работе', tab: 'В работе' },
    done: { label: 'Завершено', tab: 'Завершённые' },
    rej: { label: 'Отклонено', tab: 'Отклонённые' },
};

export const PRIORITY_META: Record<RequestPriority, { label: string }> = {
    low: { label: 'Низкий' },
    mid: { label: 'Средний' },
    high: { label: 'Высокий' },
};

export const THEMES: string[] = ['Проблема с авторизацией', 'Другое'];

export const ANSWER_SLA_DAYS = 3;